
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum/login",
      function () {
        return require("private-next-pages/forum/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forum/login"])
      });
    }
  